/**
 * Marca visual del ambiente (franja, título, favicon) — estándar `config-y-ambientes` de Bedekken.
 *
 * - Producción no lleva marca: la ausencia es la señal.
 * - Ambiente vacío o desconocido se marca como pruebas ("SIN AMBIENTE"): un build mal etiquetado
 *   nunca se hace pasar por producción.
 * - El ambiente llega en el build por REACT_APP_ENVIRONMENT (QA, PROD).
 */

const AMBIENTE_DEL_BUILD = process.env.REACT_APP_ENVIRONMENT || "";
const PROD = ["prod", "production"];
const LOCAL = ["local", "dev", "development", "test"];
const LEYENDA_PRUEBAS = "Ambiente de pruebas · lo que cargues acá no afecta el sistema real";
const LEYENDA_DESARROLLO = "Ambiente de desarrollo · lo que cargues acá no afecta el sistema real";
const HEX = { prueba: "#9a4f0a", dev: "#475569" };

export function marcaDeEntorno(valor) {
  const v = (valor || "").trim().toLowerCase();
  if (PROD.includes(v)) return { esProd: true, sigla: "PROD", leyenda: "", tono: "prueba" };
  if (LOCAL.includes(v)) return { esProd: false, sigla: "DEV", leyenda: LEYENDA_DESARROLLO, tono: "dev" };
  return { esProd: false, sigla: v === "" ? "SIN AMBIENTE" : v.toUpperCase().slice(0, 12), leyenda: LEYENDA_PRUEBAS, tono: "prueba" };
}

export const ENTORNO = marcaDeEntorno(AMBIENTE_DEL_BUILD);

export const colorDeEntorno = (marca = ENTORNO) => HEX[marca.tono];

/** `[QA] Nombre`. Idempotente: limpia un prefijo previo. En prod devuelve el título limpio. */
export function tituloConEntorno(titulo, marca = ENTORNO) {
  const limpio = titulo.replace(/^\[[^\]]*\]\s*/, "");
  return marca.esProd ? limpio : `[${marca.sigla}] ${limpio}`;
}

/** Favicon con la sigla del ambiente. Borra todos los <link rel="icon"> antes de poner el suyo. */
export function aplicarFaviconDeEntorno(marca = ENTORNO) {
  if (marca.esProd || typeof document === "undefined") return;
  const texto = marca.sigla.replace(/\s+/g, "").slice(0, 3);
  const fuente = texto.length >= 3 ? 12 : 15;
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">` +
    `<rect width="32" height="32" rx="7" fill="${colorDeEntorno(marca)}"/>` +
    `<text x="16" y="22" text-anchor="middle" font-family="Helvetica,Arial,sans-serif"` +
    ` font-size="${fuente}" font-weight="bold" fill="#ffffff">${texto}</text></svg>`;
  document.querySelectorAll('link[rel~="icon"]').forEach((viejo) => viejo.remove());
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/svg+xml";
  link.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
  document.head.appendChild(link);
}

/** Título y favicon: se llama una vez al arrancar. */
export function marcarPestaniaDeEntorno() {
  if (typeof document === "undefined") return;
  document.title = tituloConEntorno(document.title);
  aplicarFaviconDeEntorno();
}
